<template>
  <NuxtLinkLocale class="logo-wrapper block" :to="$localePath('/')">
    <h1 class="flex items-center text-white m-0">
      <i class="icon img i-local:logo-1 text-size-32px block mr-10px" />
      <span class="text-22px">Feee.io</span>
    </h1>
  </NuxtLinkLocale>
</template>
